package com.essntl.features.message.data.supabase.conversation

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [ConversationSupabaseDataSource::class])
class ConversationSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<ConversationDto> {
    override val tableName: String = "conversation"
}
